import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 4v18m8.005-12l-8-8-8 8",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgArrowUpinline;
